module.exports = __webpack_public_path__ + "img/portrait-095.345c9d2c.jpg";